var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fillRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2,
    clipRule: "evenodd",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#004113",
    fillRule: "nonzero",
    d: "M163 901c-108-50-94-175 36-314 121-129 189-154 256-95 35 30 101 117 93 122-1 1-41 8-88 15-105 16-161 34-223 73-67 42-93 104-71 163 10 26 63 45 94 33 17-6 22-6 15 1-21 21-69 22-112 2z",
    transform: "matrix(.6794 0 0 .6794 -139.746 -273.216) matrix(1.50741 0 0 -1.50741 100.548 1816.89)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00853E",
    fillRule: "nonzero",
    d: "M383 890c57-45 41-127-33-178-22-15-18.732-9.732-19.732-13.732 0-7 99-33 104-27C468.268 714.268 470 741 470 773c0 65-49 136-94 137-16 0-15-3 7-20z",
    transform: "matrix(.6794 0 0 .6794 -139.746 -273.216) matrix(1.50741 0 0 -1.50741 100.548 1816.89)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.548676ba78f4a1ea8dcb2577e141e779.svg";
export { ForwardRef as ReactComponent };